/* eslint-disable complexity */
import { ReactElement } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

const containerDiv = css({
    maxWidth: "1200px",
    margin: "0 auto"
});

const flexDiv = css({
    display: "flex",
    [media.below.md]: {
        flexDirection: "column"
    }
});

const leftContent = css({
    position: "relative"
});
const rightContent = css({
    position: "relative"
});

const rightContainer = css({
    backgroundColor: "#f4f5f7",
    minWidth: "300px",
    flex: "initial",
    paddingBlockEnd: "100px",
    position: "relative",
    [media.above.md]: {
        "paddingBlockStart": token("space.250"),
        "&:before": {
            content: "",
            position: "absolute",
            inset: "0 auto 0 0",
            width: "1000px",
            height: "100%",
            backgroundColor: "#f4f5f7"
        },
        "padding": `${token("space.400")} ${token("space.300")} 0 ${token(
            "space.300"
        )}`
    },
    [media.below.md]: {
        backgroundColor: "#ffffff",
        borderBlockStart: "1px solid #c1c7d0",
        paddingBlockStart: token("space.200")
    }
});

const leftContainer = css({
    backgroundColor: "#ffffff",
    position: "relative",
    [media.above.md]: {
        "paddingBlockStart": token("space.250"),
        "paddingBlockEnd": "100px",
        "width": "75%",
        "maxWidth": "1000px",
        "paddingInlineStart": token("space.250"),
        "&:before": {
            content: "",
            position: "absolute",
            inset: "0 0 0 auto",
            width: "2000px",
            height: "100%",
            backgroundColor: "#ffffff"
        }
    },
    [media.below.md]: {
        paddingBlockStart: token("space.200")
    }
});

type DropdownLayoutProps = {
    main: ReactElement;
    sidebar: ReactElement;
};

export const DropdownLayout = ({ main, sidebar }: DropdownLayoutProps) => {
    return (
        <div css={containerDiv}>
            <div css={flexDiv}>
                <div css={leftContainer}>
                    <div css={leftContent}>{main}</div>
                </div>
                <div css={rightContainer}>
                    <div css={rightContent}>{sidebar}</div>
                </div>
            </div>
        </div>
    );
};
